import APILibrary, { ClassExtender, GenerateResource } from './APILibrary';
import {
  InterviewEventTypeAttributes,
  InterviewEventTypeBelongsTo,
  InterviewEventTypeHasMany,
  InterviewEventTypeHasOne,
  InterviewEventTypeInterface,
  InterviewEventTypeResource,
  InterviewEventTypeResourceClass,
} from 'util/resources/InterviewEventType';

/**
 * Utility interfaces
 */
export interface EmployerInterviewEventTypeResource extends InterviewEventTypeResource {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<InterviewEventTypeAttributes>({
    queryName: 'employers/interview_event_types',
    className: 'EmployerInterviewEventType',
    AttributesClass: InterviewEventTypeAttributes,
    BelongsToClasses: [
      {
        Klass: InterviewEventTypeBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: InterviewEventTypeHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: InterviewEventTypeHasMany,
      },
    ],
  });

export class EmployerInterviewEventTypeResource extends ClassExtender<InterviewEventTypeInterface>(
  BaseClass,
  InterviewEventTypeResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerInterviewEventType =
  APILibrary.createResource<EmployerInterviewEventTypeResource>(EmployerInterviewEventTypeResource);
